import fr from 'facet-rest';
import { metaOverrideSet as DefaultStepMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/DefaultStep';
import QuickEditClosingCosts
  from 'Views/Page/Content/Modal/Layouts/PropertyBuyStrategyPropertyClosingCostsStep/QuickEdit';
import DateOrMonthForGroupedInputPicker from 'Components/ComponentLibrary/Molecules/DateOrMonthForGroupedInputPicker';

export default fr.metaOverride({ base: DefaultStepMetaOverrideSet })
  .nameOverride('dateOfPurchase', {
    _component: () => DateOrMonthForGroupedInputPicker,
    _customProps: {
      testName: 'date-or-month-picker',
    },
  })
  .nameOverride('sellDate', {
    _component: () => DateOrMonthForGroupedInputPicker,
    _customProps: {
      testName: 'date-or-month-picker',
    },
  })
  .nameOverride('closingCosts', {
    _component: () => QuickEditClosingCosts,
  });
